import Otl from './Otl';
export default Otl;